import axios from './axios-instance'

export default {
  async likeUser(id, action) {
    // action if true = unlike, else it is like
    // We need to move /like into the api, currently its outside of the api
    return axios.post(`${window.location.origin}/like`, {
      type: 'profile',
      id,
      action: action ? 'like' : 'unlike',
    })
  },
  async getFeed(q = {}) {
    // The q below is setup with its standard inputs to the api endpoint
    q = {
      s: '',
      rating: '',
      exp: '',
      rate: '',
      hours: '',
      areas: '',
      market: 'dk',
      sort: 'relevance',
      match: 'broad',
      page: '1',
      category_id: '',
      own: false,
      engaged: '',
      division: '',
      ...q,
    }
    const mlString = `
    /profiles/feed?
    s=${q.s.replace(/(\r?\s|\r)/gm, '%20')}&
    rating=${q.rating}&
    exp=${q.exp}&
    rate=${q.rate}&
    hours=${q.hours}&
    areas=${q.areas}&
    market=${q.market}&
    sort=${q.sort}&
    match=${q.match}&
    page=${q.page}&
    category_id=${q.category_id}&
    ${q.own ? `own=${q.own}&` : ''}
    ${q.own ? `divisions=${q.division}&` : ''}
    engaged=${q.engaged}&
    `.replace(/(\r[\n\s]|[\n\s]|\r)/gm, '')

    return axios.get(window.location.origin + mlString)
  },
}
